export default "__VITE_ASSET__CdHbzma___"